export default __webpack_public_path__ + "09b7dcf16045efea680cd005825df695.png";